import { render, staticRenderFns } from "./Singleitemview2.vue?vue&type=template&id=4827eb22&"
import script from "./Singleitemview2.vue?vue&type=script&lang=js&"
export * from "./Singleitemview2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports